//
//
//
//
//
//
//
//
//


export default {
  name: "Feedback",
  mounted() {
  },
  data: () => ({
    loading: false,
  }),
  methods: {}
}
